export default __webpack_public_path__ + "static/media/crop_type_rice.16ca5e3c.jpg";